export default "__VITE_ASSET__1323db20__"